@if (collectForm) {
  <form [formGroup]="collectForm" (ngSubmit)="onSubmit()" #collectNgForm="ngForm">
    <div class="collect__inputs">
      <div class="collect__info-inputs">
        <div class="collect__input-container">
          <mat-form-field appearance="fill" class="collect__input collect__input--stretch">
            <mat-label>Location</mat-label>
            <input
              type="text"
              #collect_location
              matInput
              [matAutocomplete]="location_auto"
              formControlName="collect_location"
              [ngClass]="{ 'is-success' : collectForm.get('collect_location').valid && collectForm.get('collect_location').dirty, 'is-danger' : !collectForm.get('collect_location').valid }"
              aria-label="Location"
              >
            <mat-autocomplete #location_auto="matAutocomplete" panelWidth="unset">
              @for (collect_location of filteredCollectLocations$ | async; track collect_location) {
                <mat-option [value]="collect_location.name">
                  <img class="collect__example-option-img" aria-hidden [src]="collect_location.logo" height="10">
                  <span>{{ collect_location.name }}</span> |
                  <small>Floor: {{ collect_location.floor }} | </small>
                  <small>Suite: {{ collect_location.suite }}</small>
                </mat-option>
              }
            </mat-autocomplete>
            <mat-error [hidden]="collectForm.get('collect_location').valid" align="end">Location is required and must be from the list.</mat-error>
          </mat-form-field>
        </div>
        <div class="collect__input-container">
          <mat-form-field appearance="fill" class="collect__input collect__input--stretch">
            <mat-label>Collector Name</mat-label>
            <input
              type="text"
              #collector
              matInput
              [matAutocomplete]="collector_auto"
              formControlName="collector"
              [ngClass]="{'is-success' : collectForm.get('collector').valid && collectForm.get('collector').dirty, 'is-danger' : !collectForm.get('collector').valid }"
              aria-label="Collector"
              >
            <mat-autocomplete #collector_auto="matAutocomplete" panelWidth="unset">
              @for (collector of filteredCollectors$ | async; track collector) {
                <mat-option [value]="collector.name">
                  <img class="collect__example-option-img" aria-hidden [src]="collector.icon" height="10">
                  <span>{{ collector.name }}</span>
                </mat-option>
              }
            </mat-autocomplete>
            <mat-error [hidden]="collectForm.get('collector').valid" align="end">Collector is required and must be from the list</mat-error>
          </mat-form-field>
        </div>
        @if (!weighedAtContainerExpanded) {
          <div
            class="collect__input-container"
            [matTooltip]="weighedAtTooltipText()"
            matTooltipClass="standard-tooltip"
            >
            <button type="button" class="collect__collapse-btn" (click)="toggleWeighedAtContainer()">
              <img src="assets/img/chevron-down.svg" height="20px" width="20px" />
            </button>
            <span class="collect__collapsed-label">
              &nbsp;&nbsp;Customize collection time
            </span>
          </div>
        }
        @if (weighedAtContainerExpanded) {
          <div class="collect__input-container">
            <button type="button" class="collect__collapse-btn" (click)="toggleWeighedAtContainer()">
              <img src="assets/img/chevron-up.svg" height="20px" width="20px" />
            </button>
            <div class="collect__input-label">
              Weighed At
            </div>
            <mat-form-field appearance="fill" class="collect__input collect__input--weighed-at">
              <input
                matInput
                #weighed_at
                type="datetime-local"
                formControlName="weighed_at"
                [ngClass]="{'is-success' : collectForm.get('weighed_at').valid && collectForm.get('weighed_at').dirty, 'is-danger' : !collectForm.get('weighed_at').valid }"
                aria-label="Weighed At"
                >
              <mat-error [hidden]="collectForm.get('weighed_at').valid" align="end">Must be in the past.</mat-error>
            </mat-form-field>
          </div>
        }
      </div>
      <div class="collect__info-inputs">
        <div class="collect__input-container">
          <mat-form-field appearance="fill" class="collect__input collect__input--stretch">
            <mat-label>Waste Type</mat-label>
            <input
              matInput
              #waste_type
              [matAutocomplete]="waste_type_auto"
              type="text"
              formControlName="waste_type"
              [ngClass]="{'is-success' : collectForm.get('waste_type').valid && collectForm.get('waste_type').dirty, 'is-danger' : !collectForm.get('waste_type').valid }"
              aria-label="Waste Type"
              >
            <mat-autocomplete #waste_type_auto="matAutocomplete" panelWidth="unset">
              @for (waste_type of filteredWaste_Types$ | async; track waste_type) {
                <mat-option [value]="waste_type.name" class="collect__option">
                  <img class="collect__example-option-img" aria-hidden [src]="waste_type.icon" height="25">
                  <span>{{ waste_type.name }}</span>
                </mat-option>
              }
            </mat-autocomplete>
            <mat-error [hidden]="collectForm.get('waste_type').valid" align="end">Waste type is required and must be from the list.</mat-error>
          </mat-form-field>
        </div>
        <div class="collect__input-container">
          <mat-form-field appearance="fill" class="collect__input collect__input--stretch">
            <mat-label>Vendor</mat-label>
            <input
              type="text"
              #vendor
              matInput
              [matAutocomplete]="vendor_auto"
              formControlName="vendor"
              [ngClass]="{'is-success' : collectForm.get('vendor').valid && collectForm.get('vendor').dirty, 'is-danger' : !collectForm.get('vendor').valid }"
              aria-label="Vendor"
              >
            <mat-autocomplete #vendor_auto="matAutocomplete" panelWidth="unset">
              @for (vendor of filteredVendors$ | async; track vendor) {
                <mat-option [value]="vendor.name">
                  <span>{{ vendor.name }}</span>
                </mat-option>
              }
            </mat-autocomplete>
            <mat-error [hidden]="collectForm.get('vendor').valid" align="end">Vendor is required and must be from the list</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="collect__weight-inputs">
        <div class="collect__controls-container">
          <div class="collect__well">
            <button
              mat-flat-button color="accent"
              type="button"
              (click)="isHoldingReading ? unholdReading() : holdReading()"
              matTooltip="Hold or release the scale reading"
              matTooltipClass="standard-tooltip"
              >
              @if (!isHoldingReading) {
                <span>Hold</span>
              }
              @if (isHoldingReading) {
                <span>Release</span>
              }
            </button>
            <fieldset
              class="collect__measurement-type-radio-container"
              aria-label="Select volume or weight"
              >
              <label class="collect__measurement-type-radio">
                <input
                  type="radio"
                  name="measurementType"
                  value="weight"
                  [attr.checked]="usingVolume ? null : ''"
                  (change)="handleMeasurementTypeChanged($event);"
                  />
                Weight
              </label>
              <label class="collect__measurement-type-radio">
                <input
                  type="radio"
                  name="measurementType"
                  value="volume"
                  [attr.checked]="usingVolume ? '' : null"
                  (change)="handleMeasurementTypeChanged($event);"
                  />
                Volume
              </label>
            </fieldset>
          </div>
          <div
            class="collect__hold-reading-slider-container"
            matTooltip="Scale stability time"
            matTooltipClass="standard-tooltip"
            >
            <mat-slider min="0" max="5" step="1" showTickMarks>
              <input matSliderThumb [value]="holdReadingSlider" (change)="handleHoldSliderChanged($event);">
            </mat-slider>
            <span class="collect__hold-reading-slider-label">
              {{ holdSliderLabel() }}
            </span>
          </div>
        </div>
        <!-- Scale when weight is being measured -->
        @if (!usingVolume) {
          <div class="collect__input-container">
            <div class="collect__input-label">
              Scale Weight
              <button
                mat-button
                type="button"
                class="collect__scale-btn"
                [ngClass]="{ 'collect__scale-btn--connected': ss.isConnected() }"
                (click)="ss.connectOrDisconnectFromSerialPort();"
                >
                {{ ss.isConnected() ? "Connected" : "Connect" }}
              </button>
            </div>
            <mat-form-field appearance="fill" class="collect__scale-weight">
              <input
                matInput
                #scale
                type="number"
                formControlName="scale_weight"
                [ngClass]="{ 'is-success' : collectForm.get('scale_weight').valid && collectForm.get('scale_weight').dirty, 'is-danger' : !collectForm.get('scale_weight').valid }"
                aria-label="Scale Weight"
                >
              <mat-error [hidden]="collectForm.get('scale_weight').valid" align="end">
                The scale weight must be zero or greater. Add tare to the tare weight field.
              </mat-error>
              <span matSuffix class="collect__unit-suffix">{{ getScaleUnit() }}</span>
            </mat-form-field>
          </div>
        }
        <!-- Scale when volume is being entered -->
        @if (usingVolume) {
          <div class="collect__input-container">
            <div class="collect__input-label">
              Scale Weight
              <button
                mat-button
                type="button"
                class="collect__scale-btn"
                [ngClass]="{ 'collect__scale-btn--connected': ss.isConnected() }"
                (click)="ss.connectOrDisconnectFromSerialPort();"
                >
                {{ ss.isConnected() ? "Connected" : "Connect" }}
              </button>
            </div>
            <mat-form-field appearance="fill" class="collect__scale-weight">
              <input matInput value="N/A" disabled>
            </mat-form-field>
          </div>
        }
        <!-- Tare when weight is being measured -->
        @if (!usingVolume) {
          <div class="collect__input-container">
            <div class="collect__input-label">
              Tare
            </div>
            <div class="collect__tare-inputs">
              <mat-form-field appearance="fill" class="collect__input collect__input--slim">
                <input
                  type="text"
                  #container
                  [matAutocomplete]="tare_auto"
                  formControlName="container"
                  matInput
                  [ngClass]="{'is-success' : collectForm.get('container').valid && collectForm.get('container').dirty, 'is-danger' : !collectForm.get('container').valid }"
                  aria-label="Container"
                  >
                <mat-autocomplete #tare_auto="matAutocomplete" panelWidth="unset">
                  @for (container of filteredContainers$ | async; track container) {
                    <mat-option [value]="container.name">
                      <img class="collect__example-option-img" aria-hidden [src]="container.icon" height="25">
                      <span>{{ container.name }}</span>
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-error [hidden]="collectForm.get('container').valid" align="end">Tare container is required and must be from the list.</mat-error>
              </mat-form-field>
              <mat-form-field appearance="fill" class="collect__tare-weight">
                <input
                  #tare_weight
                  matInput
                  type="number"
                  formControlName="tare_weight"
                  [ngClass]="{'is-success' : collectForm.get('tare_weight').valid && collectForm.get('tare_weight').dirty, 'is-danger' : !collectForm.get('tare_weight').valid }"
                  aria-label="Tare Weight"
                  >
                <span matSuffix class="collect__unit-suffix">{{ getScaleUnit() }}</span>
                <mat-error [hidden]="collectForm.get('tare_weight').valid" align="end">Tare weight is required.</mat-error>
              </mat-form-field>
            </div>
          </div>
        }
        <!-- Container when volume is being measured -->
        @if (usingVolume) {
          <div class="collect__input-container">
            <div class="collect__input-label">
              Container
            </div>
            <div class="collect__tare-inputs">
              <mat-form-field appearance="fill" class="collect__input">
                <input
                  type="text"
                  #container
                  [matAutocomplete]="tare_auto"
                  formControlName="container"
                  matInput
                  [ngClass]="{'is-success' : collectForm.get('container').valid && collectForm.get('container').dirty, 'is-danger' : !collectForm.get('container').valid }"
                  aria-label="Container"
                  >
                <mat-autocomplete #tare_auto="matAutocomplete" panelWidth="unset">
                  @for (container of filteredContainers$ | async; track container) {
                    <mat-option [value]="container.name">
                      <img class="collect__example-option-img" aria-hidden [src]="container.icon" height="25">
                      <span>{{ container.name }}</span>
                    </mat-option>
                  }
                </mat-autocomplete>
                <mat-error [hidden]="collectForm.get('container').valid" align="end">Container is required and must be from the list.</mat-error>
              </mat-form-field>
            </div>
          </div>
        }
        <!-- Net weight when weight is being measured -->
        @if (!usingVolume) {
          <div class="collect__input-container">
            <div class="collect__input-label">
              Net Weight
            </div>
            <mat-form-field appearance="fill" class="collect__net-weight">
              <input
                #net_weight
                matInput
                type="number"
                formControlName="net_weight"
                [ngClass]="{ 'is-success' : collectForm.get('net_weight').valid && collectForm.get('net_weight').dirty, 'is-danger' : !collectForm.get('net_weight').valid }"
                >
              <span matSuffix class="collect__unit-suffix">{{ getScaleUnit() }}</span>
              <mat-error [hidden]="collectForm.get('net_weight').valid" align="end">Net weight should be equal to the scale weight minus the tare weight.</mat-error>
            </mat-form-field>
          </div>
        }
        <!-- Volume when volume is being measured -->
        @if (usingVolume) {
          <div class="collect__input-container">
            <div class="collect__input-label">
              Volume
            </div>
            <mat-form-field appearance="fill" class="collect__net-weight">
              <input
                #volume
                matInput
                formControlName="volume"
                >
              <span matSuffix class="collect__unit-suffix">{{ containerUnitLabel() }}</span>
            </mat-form-field>
          </div>
        }
      </div>
    </div>
    <div class="collect__actions-area">
      <button mat-flat-button color="accent" type="button" (click)="onSubmit(); collect_location.focus();" [disabled]="collectForm.invalid">Submit</button>
      <button mat-button type="reset" (click)="collectForm.reset(); collect_location.focus();">Reset</button>
    </div>
  </form>
}
